import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { CLEAR_AUTHENTICATION, LOGIN, LOGOUT } from '@/authentication/store/types'
import { Loading } from '@/shared/utils/vuex-loading'
import { Api } from '@/api/api'
import { Account } from '@/api/generated'
import { Credentials } from '@/api/generated/models/Credentials'
import { Anonymous } from '@/authentication/models/Anonymous'
import { Injector } from '@/config/dependency-injection'
import { TokenHolder } from '@/shared/utils/token-holder'
import { AdminTokenHolder } from '@/config/injection-tokens'

const STORE_NAME = 'authentication'

@Module({
  name: STORE_NAME,
})
export class AuthenticationModule extends VuexModule {
  public static readonly STORE_NAME: string = STORE_NAME

  public authenticatedUser: Account = Anonymous

  @Mutation
  public [CLEAR_AUTHENTICATION]() {
    this.authenticatedUser = Anonymous

    Injector.get(TokenHolder).clear()
    Injector.get<TokenHolder>(AdminTokenHolder).clear()
  }

  @Mutation
  public [LOGIN](login: Account) {
    this.authenticatedUser = login
  }

  @Mutation
  public [LOGOUT]() {
    this.authenticatedUser = Anonymous

    Injector.get(TokenHolder).clear()
    Injector.get<TokenHolder>(AdminTokenHolder).clear()
  }

  @Action({
    commit: LOGIN,
    rawError: true,
  })
  public fetchLogin(): Promise<Account> {
    return Api.Authentication.getLogin().catch(() => Anonymous)
  }

  @Loading('login')
  @Action({
    commit: LOGIN,
    rawError: true,
  })
  public login(credentials?: Credentials): Promise<Account> {
    return Api.Authentication.login({
      credentials,
    })
  }

  @Loading('logout')
  @Action({
    commit: LOGOUT,
  })
  public logout() {
    return Api.Authentication.logout()
  }
}
